import React from 'react';
import SignatureCanvas from 'react-signature-canvas';
import handleChange from './utils/handleChange';

export const SignaturePadEntity = ({ formData, setFormData, showError }) => {
  const sigPadRef = React.useRef();
  const [touched, setTouched] = React.useState(false);

  const updateSignature = () => {
    setTouched(true);
    if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
      const signatureImage = sigPadRef.current.getTrimmedCanvas().toDataURL('image/png');
      handleChange({ name: "signatureEntity", value: signatureImage }, setFormData);
    } else {
      handleChange({ name: "signatureEntity", value: "" }, setFormData);
    }
  };

  const clearSignature = () => {
    if (sigPadRef.current) {
      sigPadRef.current.clear();
      updateSignature();
    }
  };

  const isSignatureEmpty = sigPadRef.current?.isEmpty?.() ?? true;
  const shouldShowError = showError && isSignatureEmpty;

  return (
    <div style={{ textAlign: 'left' }} id="signatureScrollAnchor" name="signatureEntity">
      <h2>Signature</h2>
      <SignatureCanvas
        penColor="black"
        canvasProps={{
          width: 500,
          height: 85,
          className: 'sigCanvas',
          style: {
            border: shouldShowError ? '2px solid red' : '1px solid #333',
            borderRadius: '4px'
          }
        }}
        ref={sigPadRef}
        onEnd={updateSignature}
      />

      <div style={{ marginTop: '5px' }}>
        <button type="button" onClick={clearSignature}>
          Clear Signature
        </button>
        {shouldShowError && (
          <div style={{ color: 'red', marginTop: '4px' }}>
            Signature is required.
          </div>
        )}
      </div>
    </div>
  );
};
